import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { FaArrowLeft, FaEdit, FaTrash } from "react-icons/fa";
import { CurrentUserContext } from "../../../../App";
import * as adminApi from "../../../../service/adminApi";
import { RedirectCode400 } from "../../../RedirectCode400";

function ViewBanner() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [titlepage, setTitlePage] = useState("");

  useEffect(() => {
    if (location.state?.type === "view-banner") {
      setTitlePage("ข้อมูลแบนเนอร์");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      navigate("/");
    }
  }, [location, navigate]);

  const formatDate = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const row = [
    {
      title: "รูปแบนเนอร์",
      detail: location.state?.image || "ไม่มีข้อมูล",
    },
    {
      title: "สร้างโดย",
      detail: `${location.state?.fname || "ไม่ระบุ"} ${
        location.state?.lname || "ไม่ระบุ"
      }`,
    },
    {
      title: "วันที่สร้าง",
      detail: location.state?.create_date
        ? formatDate(location.state?.create_date)
        : "ไม่ระบุ",
    },
    {
      title: "วันที่แก้ไข",
      detail: location.state?.update_date
        ? formatDate(location.state?.update_date)
        : "ไม่ระบุ",
    },
  ];

  const deletetBanner = async (id) => {
    if (!window.confirm(`คุณต้องการลบแบนเนอร์นี้ใช่หรือไม่`)) {
      return;
    }
    let res = await adminApi.removeBanner(id);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "ลบสำเร็จ" });
        navigate("/admin/management/banner", {
          state: {
            type: "banner",
          },
        });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      navigate("/admin/management/banner", {
        state: {
          type: "banner",
        },
      });
    }
  };

  return (
    <div className="min-w-[376px] overflow-x-auto">
      <div className="flex flex-row justify-between items-center mb-[10px]">
        <div className="text-3xl md:text-[18px] text-[#747081]">
          {titlepage}
        </div>
        <div className="flex flex-row gap-2">
          <button
            onClick={() =>
              navigate("/admin/management/banner", {
                state: {
                  type: "banner",
                },
              })
            }
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#FFCC99 0% 0% no-repeat padding-box" }}
          >
            <FaArrowLeft style={{ color: "orange" }} />
          </button>
          <button
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#AFEBE3 0% 0% no-repeat padding-box" }}
            onClick={() =>
              navigate("/admin/management/banner/edit-banner", {
                state: {
                  type: "edit-banner",
                  id: location.state?.id,
                  active: location.state?.active,
                  weight: location.state?.weight,
                  image: location.state?.image,
                },
              })
            }
          >
            <FaEdit style={{ color: "green" }} />
          </button>
          <button
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
            onClick={() => deletetBanner(location.state?.id)}
          >
            <FaTrash style={{ color: "red" }} />
          </button>
        </div>
      </div>
      <div className="flex flex-row rounded-[6px] border-[#E2E2E4] border min-w-[400px] md:w-[100%] md:min-w-[300px] p-[9px_16px] w-full">
        <div className="flex flex-col w-full">
          {row.map((item, index) => {
            const isHttpLink =
              typeof item.detail === "string" && item.detail.includes("http");
            return (
              <div key={index} className="flex flex-row mb-[10px]">
                <div className="w-[30%] font-bold text-[16px] sm:text-[14px]">
                  {item.title}
                </div>
                <div className="w-[70%] break-words whitespace-normal text-[16px] sm:text-[14px] text-[#A9A7B1]">
                  {isHttpLink ? (
                    <img src={item.detail} width="400" alt="รูปแบนเนอร์" />
                  ) : (
                    item.detail
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ViewBanner;
